import Style from '../Discount.module.less';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDiscountRecommendList } from '../../../actions/discount';
import Loading from '../../../components/Loading/Loading';
import { DISCOUNT_RECOMMEND_APPTYPEENUM } from '../../../constants/discount';
import DiscRecommendCard from '../../../components/Discount/DiscountRecommend/DiscRecommendCard';
import _LogInView from '../../../components/_LogInView/_LogInView';
import { createSelector } from 'reselect';
import ScrollTopWhite from '../../../components/ScrollTopWhite/ScrollTopWhite';
import { logging, logPostInfo } from '../../../actions/log';

// const discountRecommend
let ref = null;

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function DiscountRecommend() {
  const scrollRef = useRef(null);
  const isFirstChangeReal = useRef(true);
  // const timeoutRef = useRef(null);
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const discountRecommendList = useSelector(state => state.discount.recommendAppList);
  const [realList, setRealList] = useState([[], []]);
  const [colNumber, setColNumber] = useState(2);
  const [loading, setLoading] = useState(false);
  const [initTime, setInitTime] = useState(+new Date());

  const setRealListDependOnClientAndScroll = (colNumber, clientHeight, scrollTop) => {
    const vData = discountRecommendList[`line${colNumber}List`];
    let result = [];
    vData.forEach(item => {
      const cardList = item.cardList;
      let index_Start = null,
        index_end = 0;

      for (let i = 0; i < cardList.length; i++) {
        if (!index_end && i === cardList.length - 1) {
          index_end = i;
        }
        if (item.cardList[i].top + 216 > scrollTop && index_Start === null) {
          index_Start = i;
        }
        if (item.cardList[i].top > scrollTop + clientHeight + 232) {
          index_end = i;
          break;
        }
      }
      result.push({
        cardList: cardList.slice(index_Start || 0, index_end + 1),
        height: item.height,
      });
    });
    setRealList(() => [...result]);
  };

  const handleResize = e => {
    const resizeDom = document.getElementById('DiscountRecommend');
    if (!resizeDom) return;
    const clientHeight = resizeDom.clientHeight,
      clientWidth = resizeDom.clientWidth;
    const prevNumber = colNumber;
    let curColNumber = colNumber;
    if (clientWidth >= 1082 && clientWidth < 1448) {
      setColNumber(3);
      curColNumber = 3;
    } else if (clientWidth < 1082) {
      setColNumber(2);
      curColNumber = 2;
    } else {
      setColNumber(4);
      curColNumber = 4;
    }
    if (clientHeight === 0) return;
    isFirstChangeReal.current = false;
    setRealListDependOnClientAndScroll(curColNumber, clientHeight, resizeDom.scrollTop);
    // if (!isFirstChangeReal.current && prevNumber === curColNumber) {
    //   return;
    // }
    const curColList = discountRecommendList[`line${curColNumber}List`];
    const height = curColList[0].height;
    const scrollDom = document.getElementById('DiscountRecommend');
    if (scrollDom && height <= scrollDom.clientHeight + 100 && !discountRecommendList.loading) {
      dispatch(getDiscountRecommendList({ pageCursor: discountRecommendList.pageCursor }));
    }
  };

  const handleScroll = e => {
    const scrollDom = document.getElementById('DiscountRecommend');
    // clearTimeout(timeoutRef.current);
    setRealListDependOnClientAndScroll(colNumber, scrollDom.clientHeight, scrollDom.scrollTop);
    // tabsStyleController(e);
    const curColList = discountRecommendList[`line${colNumber}List`];
    const height = curColList[0].height;
    if (e.target.scrollTop > height - e.target.clientHeight - 600) {
      // setLoading(true);
      !discountRecommendList.loading &&
        discountRecommendList.pageCursor &&
        dispatch(getDiscountRecommendList({ pageCursor: discountRecommendList.pageCursor }));
    }
  };

  const getLineHeightDependOnVDataAndColNumber = () => {
    const data = discountRecommendList[`line${colNumber}List`];
    let height = 0;
    // let dom = document.getElementsByClassName(`line-content`)[0];
    for (let i = 0; i < colNumber; i++) {
      if (data[i].height > height) {
        height = data[i].height;
      }
    }
    return height;
    // dom.style.height = height + 'px';
    // if (
    //   scrollRef.current &&
    //   height <= scrollRef.current.clientHeight - 100 &&
    //   discountRecommendList.pageCursor
    // ) {
    //   dispatch(getDiscountRecommendList({ pageCursor: discountRecommendList.pageCursor }));
    // }
  };

  // const tabsStyleController = e => {
  //   const tabsDom = document.getElementById('RouteTabs');
  //   if (window.location.pathname === '/embedded/discount/recommend' && e.target.scrollTop > 20) {
  //     tabsDom.style.paddingBottom = '18px';
  //   } else {
  //     tabsDom.style.paddingBottom = '0px';
  //   }
  // };

  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Sales_Reco`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Sales_Reco',
        label: '',
        param2: {
          source: 'Sales_Reco',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Sales_Reco',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, []);

  useActivate(() => {
    handleResize()
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });
  useActivate(() => {
    pagePvLog();
  });
  useEffect(() => {
    pagePvLog();
  }, []);

  useEffect(() => {
    dispatch(getDiscountRecommendList({ refresh: true }));
  }, []);

  useEffect(() => {
    !discountRecommendList.loading && handleResize();
    // !discountRecommendList.loading &&
    //   discountRecommendList.line2List[0].cardList.length &&
    //   setLineHeightDependOnVDataAndColNumber();
    // setLoading(false);
  }, [discountRecommendList]);

  useEffect(() => {
    const scrollDom = document.getElementById('DiscountRecommend');
    if (scrollDom) {
      scrollDom.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize);
      scrollDom && scrollDom.removeEventListener('scroll', handleScroll);
    };
  }, [colNumber, discountRecommendList, loading]);

  return (
    <div
      className={Style.DiscountRecommend}
      ref={scrollRef}
      id="DiscountRecommend"
      pagescroll="PCStore_Page_Scroll"
    >
      {discountRecommendList.loading && !discountRecommendList.line2List[0].cardList.length ? (
        <div className={Style.loading}>
          <Loading />
        </div>
      ) : (
        <div className="line-content" style={{ height: getLineHeightDependOnVDataAndColNumber() }}>
          {realList &&
            realList?.map((item, index) => (
              <div className={`line${index} line`} style={{ marginTop: 0 }} key={index}>
                {item?.cardList?.map((item_card, index_card) => (
                  <div
                    className="card-content"
                    style={{
                      position: 'absolute',
                      top: item_card.top,
                      height: item_card.height,
                    }}
                    key={item_card.id}
                  >
                    <_LogInView
                      cardData={item_card}
                      logInfo={{
                        categoryAction: 'I',
                        logAction: 'Sales_Detail',
                        source: 'Sales_Reco',
                        type: item_card.type,
                        id: item_card.id,
                      }}
                    >
                      <DiscRecommendCard item_card={item_card} index_card={index_card} />
                    </_LogInView>
                  </div>
                ))}
                {index === 1 && (
                  <div className={Style.scoll_control}>
                    <ScrollTopWhite node={scrollRef.current} quickly={true} />
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
export default () => (
  <KeepAlive name="discountRecommend">
    <DiscountRecommend />
  </KeepAlive>
);
